// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-iconbutton_default__3eu4g","icon":"idt-iconbutton_icon__1fz7q","small":"idt-iconbutton_small__1jk8g"};